module.exports = __webpack_public_path__ + "media/images/expired_barcode-bb707e9abf125d2d85f616a815669aea.png";